export default __webpack_public_path__ + "static/media/Library_16_9.31736685.png";